// PendingMessages.jsx — mensagens enfileiradas ENQUANTO o agente pensa, mostradas
// como bolhas PENDENTES no fim da conversa (estilo claude.app).
//
// O envio no meio do turno já ENFILEIRA (agentRunStore.queued; Enter roteia pro
// onQueue quando running). Antes isso só virava um contador "N na fila" — parecia
// que a mensagem sumia. Aqui o usuário VÊ o que deixou pendente (bolha esmaecida
// com relógio) e pode CANCELAR (X). Despacham em ordem quando o turno termina
// (useQueuedSendDrain). Presentacional puro.

import { Clock, X } from 'lucide-react';
import { extractAttachments } from '../../../lib/attachmentSerialization.js';

export default function PendingMessages({ items = [], onCancel }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="flex flex-col gap-2" aria-label="Mensagens pendentes" data-testid="pending-messages">
      {items.map((p, i) => {
        const { text } = extractAttachments(p?.text || '');
        const nAtt = p?.attachments?.length || 0;
        return (
          <div
            key={i}
            className="group ml-auto flex w-fit max-w-[min(46rem,86%)] items-start gap-2 rounded-[14px_14px_4px_14px] border border-dashed border-apolo-borderStrong bg-apolo-surface2/50 px-3 py-2 opacity-70"
          >
            <Clock size={12} aria-hidden="true" className="mt-0.5 shrink-0 text-apolo-textTertiary" />
            <span className="min-w-0 flex-1 whitespace-pre-wrap break-words text-left text-[13px] text-apolo-textSecondary">
              {text || '(anexos)'}
              {nAtt > 0 && (
                <span className="ml-1 text-[11px] text-apolo-textTertiary">
                  · {nAtt} {nAtt > 1 ? 'anexos' : 'anexo'}
                </span>
              )}
            </span>
            <button
              type="button"
              onClick={() => onCancel?.(i)}
              aria-label="Cancelar mensagem pendente"
              title="Cancelar (não enviar)"
              className="shrink-0 text-apolo-textTertiary opacity-0 transition hover:text-apolo-error group-hover:opacity-100"
            >
              <X size={13} aria-hidden="true" />
            </button>
          </div>
        );
      })}
      <span className="ml-auto text-[10px] text-apolo-textTertiary">
        {items.length === 1
          ? 'Pendente — envia quando o agente terminar'
          : `${items.length} pendentes — enviam em ordem`}
      </span>
    </div>
  );
}
